import { InformationMessage } from 'components/informationMessage/informationMessage';
import { formatText } from 'core/i18n';
import React from 'react';
import { getInformationMessage } from './getInformationMessage';

export const KeepInMindMessage = ({ nationality, documentType, isCountrySelectedFromEuropeanUnion }) => {
    if (!nationality) return null;

    return (
        <div className="information-message__container">
            <InformationMessage
                title={formatText('personalDataSection-keepInMind')}
                text={getInformationMessage(documentType, isCountrySelectedFromEuropeanUnion)}
            />
        </div>
    );
};
